<template>
  <el-radio
    :value="currValue"
    :label="value"
    :data-testid="value"
    size="medium"
    class="m-0 flex items-start justify-start"
  >
    <div class="m-0 rounded" :class="value === 'mt5' ? 'bg-[#010081]' : 'bg-greenG1'">
      <div class="relative px-4.5 py-6 flex flex-col items-center justify-center text-white font-[Inter]">
        <div
          v-if="value === 'mt5'"
          class="absolute -top-[3px] left-2 z-10 w-[45%] h-5 flex items-center justify-center p-1"
        >
          <svg-icon iconName="popular-frame" className="absolute left-0 right-0 top-0 bottom-0 !w-full !h-full" />
          <div class="uppercase text-2xs z-10">{{ $t('common.tag.popular') }}</div>
        </div>
        <div class="flex items-center justify-center gap-2">
          <div class="text-xl leading-none">MetaTrader</div>
          <div class="text-4xl font-bold leading-none">{{ value === 'mt5' ? '5' : '4' }}</div>
        </div>
      </div>
    </div></el-radio
  >
</template>

<script>
// Use with <el-radio-group>
export default {
  name: 'PlatformRadioButton',
  props: {
    //  slot
    currValue: {
      validator: function (value) {
        return value === null || typeof value === 'string' || typeof value === 'number';
      },
      required: true
    },
    value: { type: [String, Number], required: true }
  }
};
</script>
